import { createSelector } from "reselect";
import { getGroupList } from "./getGroups";
import { Option } from "core/components/form/select";

export const getGroupOptions = createSelector(getGroupList, (groups) =>
    groups.map<Option>(({ id: value, displayName: label }) => ({ value, label }))
);
